import type { ElementType, BuilderElement } from '@/utils/builder/types';

// Generate unique IDs
export const generateId = (elementType?: ElementType): string => {
  if (elementType === 'root-container') return 'root';
  return Math.random().toString(36).slice(2, 9);
};

// Validate that all IDs in the element tree are unique
export const validateUniqueIds = (elements: BuilderElement[]): void => {
  const seenIds = new Set<string>();

  const checkElement = (element: BuilderElement): void => {
    if (seenIds.has(element.id)) {
      throw new Error(`Duplicate ID found: ${element.id}`);
    }
    seenIds.add(element.id);
    element.children?.forEach(checkElement);
  };

  elements.forEach(checkElement);
};

// Fix duplicate IDs by regenerating them
export const validateAndFixIds = (
  elements: BuilderElement[]
): BuilderElement[] => {
  const seenIds = new Set<string>();

  const fixElement = (element: BuilderElement): BuilderElement => {
    let newId = element.id;
    if (seenIds.has(element.id)) {
      newId = generateId();
      console.log(`🔧 Fixed duplicate ID: ${element.id} -> ${newId}`);
    }
    seenIds.add(newId);

    const normalizedChildren = Array.isArray(element.children)
      ? element.children
      : element.children
        ? [element.children]
        : [];

    return {
      ...element,
      id: newId,
      children: normalizedChildren.map(fixElement),
    };
  };

  return elements.map(fixElement);
};
